import { hasOKRModuleAccess } from 'utils/app.utils';
import { PlatformTabs, ModuleTabs } from './constants';
import {
  FirebaseKeys,
  HrisIntegrationStatus,
  ModuleNames,
  UserRole
} from '../../utils/constants';
import { hasSurveyModuleAccess } from '../../utils/app.utils';

export const onSettingChange = (id, setSelectedSetting) => {
  let setting = null;
  const SettingsTabs = { ...PlatformTabs, ...ModuleTabs };
  Object.keys(SettingsTabs).forEach(s => {
    SettingsTabs[s].data.forEach(item => {
      if (item.id === id) setting = item;
    });
  });
  setSelectedSetting(setting);
};

export const validateUserAccess = (
  path,
  accessibleModules,
  userRoles,
  roleAccessModule,
  featureFlagConfig,
  orgAccessibleModules
) => {
  if (path && accessibleModules?.length && userRoles) {
    switch (path) {
      case 'members':
        return roleAccessModule.hasAdminOrSuperiorRole(userRoles);

      case 'errors':
        return roleAccessModule.hasAdminOrSuperiorRoleInApps(userRoles);

      case 'org-hierarchy': {
        const showToAllUsers =
          featureFlagConfig[FirebaseKeys.show_org_hierarchy_to_all];
        return (
          showToAllUsers ||
          roleAccessModule.hasAdminOrSuperiorRoleInApps(userRoles)
        );
      }

      case 'permissions':
        return roleAccessModule.hasAdminOrSuperiorRole(userRoles);

      case 'notifications':
      case 'integrations':
        return (
          hasOKRModuleAccess(accessibleModules) ||
          roleAccessModule.hasSlackIntegrationAccess(userRoles)
        );

      case 'visibility-controls':
      case 'objective-customization':
        return (
          hasOKRModuleAccess(accessibleModules) &&
          roleAccessModule.hasAdminOrSuperiorRoleInGoals(userRoles)
        );

      case 'module-access':
        return roleAccessModule.hasModuleAccessSettingAccess(
          userRoles,
          orgAccessibleModules
        );
      case 'data-sharing':
        return roleAccessModule.hasAdminOrSuperiorRoleInApps(userRoles);

      case 'feedback-customization':
      case 'values':
        return (
          orgAccessibleModules?.includes('FEEDBACK') &&
          roleAccessModule.hasAdminOrSuperiorRoleInPerf(userRoles)
        );
      case 'objective-permissions':
        return (
          hasOKRModuleAccess(accessibleModules) &&
          roleAccessModule.hasAdminOrSuperiorRoleInGoals(userRoles)
        );
      case 'surveys-customization':
        return (
          hasSurveyModuleAccess(accessibleModules) &&
          roleAccessModule.hasAdminOrSuperiorRoleInPeople(userRoles)
        );
      default:
        return false;
    }
  }
  return true;
};

export const translateToValidSettingsRoute = (
  path,
  accessibleModules,
  userRoles,
  roleAccessModule,
  featureFlagConfig,
  props,
  ORG_SUB_DOMAIN,
  orgAccessibleModules
) => {
  const tabs = { ...PlatformTabs, ...ModuleTabs };
  const validPaths = [];
  Object.keys(tabs).forEach(m =>
    validPaths.push(...tabs[m].data.map(d => d.id))
  );
  if (
    validPaths.includes(path) &&
    validateUserAccess(
      path,
      accessibleModules,
      userRoles,
      roleAccessModule,
      featureFlagConfig,
      orgAccessibleModules
    )
  )
    return path;
  // if invalid path, check if user has okr access. If User has Okr access, redirect to notifications, else redirect to dashboard page
  if (hasOKRModuleAccess(accessibleModules))
    props.history.replace({
      pathname: `/${ORG_SUB_DOMAIN}/settings/notifications`
    });
  else
    props.history.replace({
      pathname: `/${ORG_SUB_DOMAIN}/dashboard`
    });
};

export const shouldInviteBeDisabled = hrisStatus =>
  hrisStatus === HrisIntegrationStatus.active;

export const checkIfUserHasOnlyPeopleMemberAccess = (
  userRoles,
  roleAccessModule,
  accessibleModules
) =>
  userRoles?.people === UserRole.USER &&
  !roleAccessModule.hasAdminOrSuperiorRoleInApps(userRoles) &&
  !accessibleModules?.includes(ModuleNames.ADVANCED_OKR) &&
  !accessibleModules?.includes(ModuleNames.BASIC_OKR);
